export default __webpack_public_path__ + "static/media/CTP_Light_IT.7a3cacfc.svg";